import React from 'react';

import { Button as AntdButton } from 'antd';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';
import { FormFilterAutoriteFourriere } from 'pages/autorite-fourriere/Dashboard/DashboardHeader/Filters/types';

import './FormFooter.less';

interface FormActionProps {
  setFilter: (value: Partial<FormFilterAutoriteFourriere>) => void;
}

export function FormAction({ setFilter }: FormActionProps): React.ReactElement {
  const formActions = useBaseFormContext<FormFilterAutoriteFourriere>();

  function resetFilter() {
    formActions.setFieldsValue({
      actionsRequises: undefined,
      dateRangeMiseEnFourriere: undefined,
      dateRangeBonEnlevement: undefined,
      dateRangeSortieDefinitive: undefined,
      classement: undefined,
      fourriere: undefined,
      commune: undefined,
      natureMiseEnFourriere: undefined,
      statut: undefined,
      motifDeSortie: undefined,
      dateRangeOrdreDestruction: undefined,
      statutsTraitementFacturation: undefined,
      includeDossiersAnonymises: undefined,
      includeOnlyNotDetruitApresSorti: undefined,
    });
  }

  return (
    <div className={'form-footer-container'}>
      <AntdButton onClick={resetFilter}>Réinitialiser</AntdButton>

      <AntdButton
        type={'primary'}
        onClick={() => setFilter(formActions.getFieldsValue())}
      >
        Rechercher
      </AntdButton>
    </div>
  );
}

export default FormAction;
